import * as React from 'react';

function SvgCaCertificateOutlined(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" className="CaCertificateOutlined_svg__icon" viewBox="0 0 1024 1024" {...props}>
      <defs>
        <style />
      </defs>
      <path d="M45.176 168.237V557.96c0 89.9 56.11 182.151 166.762 274.25 73.487 61.17 154.835 108.153 206.878 135.41V825.043a991.714 991.714 0 01-110.2-76.59C200.252 660.722 177.513 596.45 177.513 557.96V199.44c84.029-28.583 160.618-45.177 241.303-52.074V25.299C311.025 33.34 209.86 56.169 97.551 97.28c-31.322 10.692-52.375 39.183-52.375 70.957M835.464 560.4c0 73.909-78.306 170.827-210.824 262.024V518.776h210.824v41.653zm27.979-483.69l-19.516-6.173v363.85c-76.319-25.147-146.794-40.718-219.257-48.368V27.076l-13.402-1.115a1205.55 1205.55 0 00-100.593-4.156l-18.372.09v979.878l14.487 1.024c1.355.12 2.71.211 3.915.211 9.818 0 24.395-2.108 36.05-8.011 22.047-9.97 429.478-197.632 429.478-437.037V168.237a74.48 74.48 0 00-52.043-70.776 1525.007 1525.007 0 00-60.747-20.751z" />
    </svg>
  );
}

export default SvgCaCertificateOutlined;
